module.exports = __webpack_public_path__ + "img/logo_frame.bf8dde86.svg";